import { GenIcon } from '../helpers/IconBase.es.js';

const PlayOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.61305 21 7.32387 20.0518 5.63604 18.364C3.94821 16.6761 3 14.3869 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12V12Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M10.9411 9.05794L14.8231 11.3539C14.9352 11.4203 15.0282 11.5147 15.0927 11.6279C15.1573 11.7411 15.1912 11.8691 15.1912 11.9994C15.1912 12.1297 15.1573 12.2578 15.0927 12.371C15.0282 12.4842 14.9352 12.5786 14.8231 12.6449L10.9411 14.9409C10.8272 15.0084 10.6974 15.0444 10.565 15.0455C10.4326 15.0465 10.3023 15.0125 10.1873 14.9469C10.0724 14.8813 9.9768 14.7864 9.91036 14.6719C9.84393 14.5574 9.80898 14.4273 9.80908 14.2949V9.70394C9.80898 9.57155 9.84393 9.4415 9.91036 9.32699C9.9768 9.21248 10.0724 9.11759 10.1873 9.05197C10.3023 8.98636 10.4326 8.95234 10.565 8.95339C10.6974 8.95444 10.8272 8.99051 10.9411 9.05794Z",
          stroke: "#82869E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      }
    ]
  })(props);
};

export { PlayOutlined };
